module.exports = __webpack_public_path__ + "media/images/icons/benefits_international_database-0d508adfbdf76af22ca69ef778ec1a24.svg";